<template>
  <div class="ticker box" v-show="show">
    <article class="media d-flex">
        <span class="breaking-news media-left align-self-center">ご存じでしたか？</span>
        <div class="media-content align-self-center">
          <transition name="fade" tag="div" mode="out-in">
            <span class="news" v-for="(n, i) in news" v-bind:key="i">{{n}}</span>
          </transition>
        </div>
    </article>
  </div>
</template>

<style scoped>
.breaking-news {
  background-color: #33A3F1;
  color: #ffffff;
  border-radius: 10px 50px 50px 10px;
  padding: 10px;
  white-space: nowrap;
}

.media-content {
  padding: 10px;
}

.news {
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>

<script>
const phrases = `
写真のような画像には、JPEGやWebPが最適です。PNGではJPEGの3倍近いファイルサイズになることも。
イラストレータで作ったパスがあるデータを画像にする時は、SVGが最適です。拡大縮小にも対応できます。
回線速度が10Mbpsだと、1MBのダウンロードは約1秒。5Mbpsだと、5秒もかかります。データはできるだけ最適化しましょう。
画像軽量化は、Google Pagespeed Insightsのスコアアップにも効果的。次世代フォーマットでの画像配信は、WebPがオススメです。
WebPは、透過画像にも対応しています。レイヤーを重ねたようなデザイン性が高い場合でも、そのクオリティを落とすことはありません。
ウェブページの転送量の多くを占めているのは画像といわれています。なんと半分以上も画像というケースがほとんどです。
Googleスピードアップデートは、著しく表示が遅い場合はペナルティが与えられます。重たい画像は表示速度をより遅くします。
画像はできるだけ遅延読み込みしましょう。ファーストビューの表示が速くなります。もちろん、スマホでも。
従量課金型のCDNのコストが高いなら、その内訳をチェックしてみましょう。きっと画像が多くを占めているはずです。画像軽量化すれば、コストダウンが可能です。
WebP配信や画像軽量化は、あなただけの問題ではありません。閲覧者にとって、表示が速くなり、ギガが減るのを抑制します。
Googleが推奨する1ページのファイルサイズは、1.6MB。3G回線でも10秒以内に表示される想定です。
`.split(/\n/).filter(l => !!l);

export default {
  props: {
    delay: {
      type: Number,
      default: 1 * 1000,
    },
    interval: {
      type: [String, Number],
      default: 9 * 1000,
    },
  },
  data() {
    return {
      show: false,
      tickerLocation: 0,
      news: phrases,
    }
  },
  created: function() {
    setTimeout(() => {
      this.show = true;
      setInterval(this.updateTicker, 10 * 1000);
    }, this.delay);
  },
  methods: {
    updateTicker: function() {
      var removed = this.news.pop();
      this.news.unshift(removed);
    }
  }
}
</script>